export default "__VITE_ASSET__19a30b4f__"